import React, { useContext, useState, useEffect } from 'react'
import firebase from 'firebase'

import { FirebaseContext } from '../firebase'
import { useHistory } from 'react-router-dom'

function ArticleLink(props) {

    const { fire, user } = useContext(FirebaseContext)
    const [read, setRead] = useState(false)
    const history = useHistory()

    let styles = {}
    // if (props.article.id === props.activeArticle.id) {
    //     styles = {
    //         background: "#ededed",
    //         borderLeft: "8px solid #2775d1",
    //         paddingLeft: 8
    //     }
    // }

    useEffect(() => {
        if (props.article.readBy) {
            if (user && props.article.readBy.includes(user.uid)) {
                setRead(true)
            }
        }
    }, [])

    function handleChange(article) {
        if (!user) {
            history.push("/login")
        } else {
            const articleRef = fire.firestore().collection('articles').doc(article.id)
            articleRef.get().then(doc => {
                if (doc.data().readBy && doc.data().readBy.includes(user.uid)) {
                    markUnread(articleRef)
                } else {
                    markRead(articleRef)
                }
            })
                .catch(err => console.log(err))
        }
    }

    function markRead(articleRef) {
        articleRef.update({
            readBy: firebase.firestore.FieldValue.arrayUnion(user.uid)
        })
        setRead(true)
    }

    function markUnread(articleRef) {
        articleRef.update({
            readBy: firebase.firestore.FieldValue.arrayRemove(user.uid)
        })
        setRead(false)
    }

    return (
        <div
            style={styles}
            className="d-flex article-link">
            <div>
                <input type="checkbox" onChange={() => handleChange(props.article)} checked={read} />
            </div>
            <div className="text-break" style={{ marginLeft: 10 }} onClick={() => { 
                history.push(`/sequence/${props.sequence.id}/${props.article.id}`)
            }}>
                {props.article.title}
                <br />
                <small className="text-muted text-break">{props.article.url}</small>
            </div>
        </div>
    )
}

export default ArticleLink